import { ApiAction, initialApiState, ApiState } from '../../utils/requestAction'
import requestReducer from '../requestReducer'

export interface InvoiceTotalIntervalState extends ApiState {
  total?: number
}

const InvoiceTotalInterval = (state: InvoiceTotalIntervalState = initialApiState, action: ApiAction) => {
  switch (action.type) {
    default:
      return requestReducer<InvoiceTotalIntervalState>('INVOICE_TOTALS')(state, action)
  }
}

export default InvoiceTotalInterval
